"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _mobileSearchBarStyles = _interopRequireDefault(require("./mobileSearchBarStyles"));
var _headerContext = require("./headerContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function MobileSearchBar(_ref) {
  let {
    searchCallback,
    searchPlaceHolder
  } = _ref;
  const classes = (0, _mobileSearchBarStyles.default)();
  return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, _ref2 => {
    let {
      state,
      actions
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
      className: classes.header
    }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
      className: classes.toolbar
    }, /*#__PURE__*/_react.default.createElement("form", {
      className: classes.search,
      onSubmit: evt => {
        evt.preventDefault();
        actions.submitSearch(state.inputValue);
        searchCallback(state.inputValue);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Input, {
      id: "sui-search-bar-mobile",
      autoFocus: state.searching || state.typing,
      disableUnderline: true,
      placeholder: searchPlaceHolder,
      fullWidth: true,
      onChange: evt => actions.typing(evt.target.value),
      classes: {
        root: classes.inputBaseRoot,
        input: classes.inputBase
      },
      startAdornment: state.final ? /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.searchButtons
      }, /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, null))) : /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: state.fromHome ? actions.clickLogo : actions.backToSearchResult,
        classes: {
          root: classes.searchButtons
        },
        disableRipple: true
      }, /*#__PURE__*/_react.default.createElement(_icons.ArrowBack, null))),
      endAdornment: state.inputValue !== '' || state.typing || state.final ? /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: actions.clickClearSearchbar,
        className: classes.searchButtons
      }, /*#__PURE__*/_react.default.createElement(_icons.Close, null))) : null,
      value: state.inputValue,
      onFocus: actions.clickBottomSearch
    }))));
  });
}
MobileSearchBar.propTypes = {
  searchCallback: _propTypes.default.func.isRequired,
  searchPlaceHolder: _propTypes.default.string.isRequired
};
var _default = exports.default = MobileSearchBar;